import React from 'react'

const HeaderSocials = () => {
  return (
    <div className="home__socials">
        <a href="#home" className="home__social-link" target="_blank">
        <i class="fa-brands fa-instagram"></i>
        </a>

        <a href="https://www.facebook.com/holahoog"  className="home__social-link" target="_blank" rel="noreferrer">
        <i class="fa-brands fa-facebook"></i>
        </a>

        <a href="https://wa.link/h7svyf" className="home__social-link" target="_blank" rel="noreferrer">
        <i class="fa-brands fa-whatsapp"></i>
        </a>

        <a href="https://www.behance.net/gabrielchv" className="home__social-link" target="_blank" rel="noreferrer">
        <i class="fa-brands fa-behance"></i>
        </a>
    </div>
  )
}

export default HeaderSocials